/**
 * Удаляет указанные поля из объекта
 * @param {Object} obj - Объект, из которого нужно удалить поля
 * @param {string[]} fieldsToOmit - Список ключей, которые нужно удалить
 * @returns {Object} Новый объект без указанных полей
 */
export function omitFields(obj, fieldsToOmit = []) {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !fieldsToOmit.includes(key))
  );
}
